import { ExceptionEvent } from "@fairfleet/geotab";
import SendIcon from "@mui/icons-material/Send";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { t } from "i18next";
import { useState } from "react";
import EventComment from "./faultDetail/EventComment";
import { useGeotabClient } from "@/components/GeotabClientContext";
import { useAddExceptionEventComment } from "@/hooks/exceptionEvent/useAddExceptionEventComment";
import { useExceptionEventCommentsByEventId } from "@/hooks/exceptionEvent/useExceptionEventCommentsByEventId";
import isDemo from "@/utilities/isDemo";

export default function CommentSection({ event }: { event: ExceptionEvent }) {
  const { me } = useGeotabClient();
  const [commentValue, setCommentValue] = useState<string>("");
  const addComment = useAddExceptionEventComment();
  const { data: comments = [] } = useExceptionEventCommentsByEventId(event.id);
  const handleAddComment = () => {
    if (commentValue) {
      addComment.mutate({
        comment: commentValue,
        event,
        me,
      });
      setCommentValue("");
    }
  };
  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", mt: 2, mb: 2 }}>
        <TextField
          value={commentValue}
          onChange={e => setCommentValue(e.target.value)}
          label={t("faultOverview.comment")}
          variant="outlined"
          sx={{ flex: 1 }}
          disabled={isDemo}
        />
        <Tooltip title={t("faultOverview.addComment")}>
          <IconButton onClick={handleAddComment} disabled={isDemo} sx={{ ml: 1 }}>
            <SendIcon />
          </IconButton>
        </Tooltip>
      </Box>

      <Box sx={{ mt: 2 }}>
        <Typography variant="h6">{t("faultOverview.comments")}</Typography>
        {comments.length > 0 ? (
          comments.map(comment => <EventComment key={comment.id} comment={comment} />)
        ) : (
          <Typography>{t("faultOverview.noComments")}</Typography>
        )}
      </Box>
    </>
  );
}
